import { defineMessage } from 'services/localization';

export const messages = {
    everyDay: defineMessage('every_day'),
    everyDaysOfWeek: defineMessage('b_n_b_days_of_the_b_day_of_week_b'),
    everyDaysOfMonth: defineMessage('b_n_b_days_of_the_b_day_of_month_b'),
    specificDayOfWeek: defineMessage('specific_day_of_the_week_one_or_many'),
    specificDayOfMonth: defineMessage('specific_day_of_the_month_choose_one_or_many'),
    lastDayOfMonth: defineMessage('on_the_last_day_of_the_month'),
    lastWeekdayOfMonth: defineMessage('on_the_last_weekday_of_the_month'),
    lastDayOfWeekOfMonth: defineMessage('b_day_of_week_b_of_the_month'),
    lastNDaysBeforeMonthEnd: defineMessage('b_n_b_days_before_the_end_of_the_month'),
    nearestWeekdayToDay: defineMessage('b_n_b_of_the_month'),
    dayAndWeekdayOfMonth: defineMessage('b_n_b_b_day_of_week_b_of_the_month'),
    every: defineMessage('every'),
    startingDays: defineMessage('days_starting_on_the'),
    month: defineMessage('of_the_month'),
    last: defineMessage('on_the_last'),
    beforeEnd: defineMessage('days_before_the_end_of_the_month'),
    nearestWeekday: defineMessage('nearest_weekday_monday_to_friday_to_the'),
    onThe: defineMessage('on_the'),
    dayScheduler: defineMessage('day_scheduler'),
    monday: defineMessage('monday'),
    tuesday: defineMessage('tuesday'),
    wednesday: defineMessage('wednesday'),
    thursday: defineMessage('thursday'),
    friday: defineMessage('friday'),
    saturday: defineMessage('saturday'),
    sunday: defineMessage('sunday'),
};
